import { library } from '@fortawesome/fontawesome-svg-core';
import { 
  faFire, 
  faHouse,
  faFolderOpen,
  faFolderPlus,
  faHeart,
  faUser,
  faUserPlus,
  faRightFromBracket,
  faMagnifyingGlass,
  faShare,
  faShareAlt,
  faThumbsUp,
  faPlus,
  faChevronDown,
  faChevronUp,
  faChevronLeft,
  faChevronRight,
  faBars,
  faXmark,
  faCircleInfo,
  faCamera,
  faTimes,
  faEdit,
  faSave,
  faCopy,
  faCircleHalfStroke,
  faEnvelope,
  faArrowLeft,
  faArrowRight,
  faTh,
  faList,
  faSearch,
  faFilter,
  faCube,
  faCubes,
  faFolder,
  faPuzzlePiece,
  faCheck,
  faCheckCircle,
  faShoppingBasket,
  faInfoCircle,
  faMapMarkerAlt,
  faTrash,
  faStore,
  faDollarSign,
  faEyeSlash,
  faEye,
  faSortDown,
  faSortUp,
  faBoxOpen,
  faBox,
  faUserCircle,
  faGift,
  faPiggyBank,
  faUsers,
  faClock,
  faTableCells,
  faListUl,
  faComment,
  faCommentDots,
  faPenToSquare,
  faFeather,
  faFileLines,
  faNewspaper,
  faCog,
  // Rich text editor toolbar icons
  faBold,
  faItalic,
  faUnderline,
  faStrikethrough,
  faCode,
  faListOl,
  faQuoteRight,
  faFileCode,
  faMinus,
  faAlignLeft,
  faAlignCenter,
  faAlignRight,
  faLink,
  faImage,
  faImages,
  faUpload,
  faCloudArrowUp,
  faSpinner,
  faRotateLeft,
  faRotateRight,
  faCircleExclamation,
  // Blog post icons
  faReply,
  faTag,
  faArrowsRotate,
  // Trophy / admin icons
  faTrophy,
  faAward,
  faCrown,
  faMedal,
  faUserCheck,
  faExternalLinkAlt,
  faHome,
} from '@fortawesome/free-solid-svg-icons';

import {
  faGithub,
  faTwitter,
  faXTwitter,
  faFacebook,
  faYoutube
} from '@fortawesome/free-brands-svg-icons';

// Add all icons in a single call
library.add(
  // Solid icons
  faFire,
  faHouse,
  faFolderOpen,
  faFolderPlus,
  faHeart,
  faUser,
  faUserPlus,
  faRightFromBracket,
  faMagnifyingGlass,
  faShare,
  faShareAlt,
  faThumbsUp,
  faPlus,
  faXmark,
  faChevronDown,
  faChevronUp,
  faChevronLeft,
  faChevronRight,
  faBars,
  faCircleInfo,
  faCamera,
  faTimes,
  faEdit,
  faSave,
  faCopy,
  faCircleHalfStroke,
  faEnvelope,
  faArrowLeft,
  faArrowRight,
  faTh,
  faList,
  faTableCells,  // Alternative for faTh
  faListUl,      // Alternative for faList
  faSearch,
  faFilter,
  faCube,
  faCubes,
  faFolder,
  faPuzzlePiece,
  faCheck,
  faCheckCircle,
  faShoppingBasket,
  faInfoCircle,
  faMapMarkerAlt,
  faTrash,
  faStore,
  faDollarSign,
  faEyeSlash,
  faEye,
  faSortDown,
  faSortUp,
  faBoxOpen,
  faBox,
  faUserCircle,
  faGift,
  faPiggyBank,
  faUsers,
  faClock,
  faComment,
  faCommentDots,
  faPenToSquare,
  faFeather,
  faFileLines,
  faNewspaper,
  faCog,

  // Rich text editor toolbar icons
  faBold,
  faItalic,
  faUnderline,
  faStrikethrough,
  faCode,
  faListOl,
  faQuoteRight,
  faFileCode,
  faMinus,
  faAlignLeft,
  faAlignCenter,
  faAlignRight,
  faLink,
  faImage,
  faImages,
  faUpload,
  faCloudArrowUp,
  faSpinner,
  faRotateLeft,
  faRotateRight,
  faCircleExclamation,

  // Blog post icons
  faReply,
  faTag,
  faArrowsRotate,

  // Trophy / admin icons
  faTrophy,
  faAward,
  faCrown,
  faMedal,
  faUserCheck,
  faExternalLinkAlt,
  faHome,

  // Brand icons
  faGithub,
  faTwitter,
  faXTwitter,
  faFacebook,
  faYoutube
);